import { useState, useCallback, useEffect } from 'react';

import { getInitialThemeMode, saveThemeMode, type ThemeMode } from '@/theme';

export const useThemeMode = () => {
  const [mode, setMode] = useState<ThemeMode>(getInitialThemeMode);

  // Save to localStorage whenever mode changes
  useEffect(() => {
    saveThemeMode(mode);
  }, [mode]);

  const toggleMode = useCallback(() => {
    setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
  }, []);

  const setLightMode = useCallback(() => {
    setMode('light');
  }, []);

  const setDarkMode = useCallback(() => {
    setMode('dark');
  }, []);

  return {
    mode,
    toggleMode,
    setLightMode,
    setDarkMode,
    isDark: mode === 'dark',
    isLight: mode === 'light',
  };
};